// extracted by mini-css-extract-plugin
export default {"menuOpen":"Options_menuOpen__h8skC","optionDisabled":"Options_optionDisabled__QkUI7"};